'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BEGIN_TASK = exports.BEGIN_TASK = '@@redux-nprogress/BEGIN_TASK';
var END_TASK = exports.END_TASK = '@@redux-nprogress/END_TASK';